export default function TransferService($http, appSettings) {
  'ngInject';
  var resourceUrl = '/' + appSettings.IcebergApiEquipmentEndpoint.split('/')[3] + '/equipment/';

  this.getResourceUrl = function () {
    return resourceUrl;
  };

  this.getTransferKeys = function () {
    var endpoint = appSettings.IcebergApiTransfersEndpoint + '/keys';

    return $http.get(endpoint);
  };

  this.transferResources = function (transferKey, resourcesArray) {
    var endpoint = appSettings.IcebergApiTransfersEndpoint + '/keys/' + transferKey;

    return $http.post(endpoint, resourcesArray);
  };

  this.getMoreTransfers = function (moreLink) {
    var endpoint = appSettings.IcebergApiTransfersEndpoint + '/' + moreLink.substr(moreLink.indexOf('/', 1) + 1);

    return $http.get(endpoint);
  };
  this.getTransfers = function (query, limit) {
    var endpoint = appSettings.IcebergApiTransfersEndpoint + '/transfers?limit=' + limit + (query == '' ? '' : '&') + query;

    return $http.get(endpoint);
  };
  this.getTransferKeysToShare = function () {
    var endpoint = appSettings.InReachApiEndpoint + '/transfers/keys?filter=equipment:share:outbound';

    return $http.get(endpoint);
  };
  this.postEquipmentToShare = function (key, equipsShareObject) {
    var endpoint = appSettings.InReachApiEndpoint + '/share/' + key + '/execute';
    return $http.post(endpoint, equipsShareObject);
  };
}